import React, { memo } from 'react';
import { UIUrvalConditionObjectType } from 'src/Types/UrvalTypes';
import ExtendedCondition from './Components/ExtendedCondition/ExtendedCondition';
import NonExtendedCondition from './Components/NonExtendedCondition';
import { isValidForTypeConditionObject } from './Components/TypeTreePicker/Utils/typeConditionUtils';
import { ITypeConditionInfo } from '../../Utils/urvalUtils';

interface IProps {
  conditionObject: UIUrvalConditionObjectType;
  setConditionObject: (
    index: number,
    typeConditionInfo: ITypeConditionInfo | undefined,
    newConditionObject: UIUrvalConditionObjectType
  ) => void;
  deleteConditionObject: (index: number) => void;
  indention: number;
  disabled?: boolean;
  test?: () => void;
  index: number;
  typeConditionInfo: ITypeConditionInfo | undefined;
}

const Condition: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const setConditionObject = (
    newConditionObject: UIUrvalConditionObjectType
  ) => {
    props.setConditionObject(
      props.index,
      props.typeConditionInfo,
      newConditionObject
    );
  };

  const deleteConditionObject = () => {
    props.deleteConditionObject(props.index);
  };

  const { conditionObject, indention, typeConditionInfo, disabled } = props;

  const typeConditionObject =
    typeConditionInfo != null ? typeConditionInfo.object : undefined;

  if (conditionObject.type === 'Extended') {
    const isValidForType = isValidForTypeConditionObject(
      conditionObject,
      typeConditionObject
    );

    return (
      <ExtendedCondition
        conditionObject={conditionObject}
        setConditionObject={setConditionObject}
        deleteConditionObject={deleteConditionObject}
        indention={indention}
        disabled={disabled || !isValidForType}
      />
    );
  } else {
    const isValidForType = isValidForTypeConditionObject(
      conditionObject,
      typeConditionObject
    );

    return (
      <NonExtendedCondition
        indention={indention}
        conditionObject={conditionObject}
        setConditionObject={setConditionObject}
        deleteConditionObject={deleteConditionObject}
        disabled={
          disabled || !isValidForType || !!conditionObject.disableInUrval
        }
      />
    );
  }
};

export default memo(Condition);
